var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolesView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 20.5H14.3359C14.0626 20.5 13.8359 20.2733 13.8359 20C13.8359 19.7267 14.0626 19.5 14.3359 19.5H21.0026C21.2759 19.5 21.5026 19.7267 21.5026 20C21.5026 20.2733 21.2759 20.5 21.0026 20.5Z",
    fill: "#333853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 15.834H14.3359C14.0626 15.834 13.8359 15.6073 13.8359 15.334C13.8359 15.0607 14.0626 14.834 14.3359 14.834H21.0026C21.2759 14.834 21.5026 15.0607 21.5026 15.334C21.5026 15.6073 21.2759 15.834 21.0026 15.834Z",
    fill: "#333853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 11.166H14.3359C14.0626 11.166 13.8359 10.9393 13.8359 10.666C13.8359 10.3927 14.0626 10.166 14.3359 10.166H21.0026C21.2759 10.166 21.5026 10.3927 21.5026 10.666C21.5026 10.9393 21.2759 11.166 21.0026 11.166Z",
    fill: "#333853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66891 11.8343C9.54224 11.8343 9.41557 11.7876 9.31557 11.6876L8.64891 11.0209C8.45557 10.8276 8.45557 10.5076 8.64891 10.3143C8.84224 10.1209 9.16224 10.1209 9.35557 10.3143L9.66891 10.6276L11.3156 8.98094C11.5089 8.7876 11.8289 8.7876 12.0222 8.98094C12.2156 9.17427 12.2156 9.49427 12.0222 9.6876L10.0222 11.6876C9.92224 11.7876 9.79557 11.8343 9.66891 11.8343Z",
    fill: "#333853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66891 16.5003C9.54224 16.5003 9.41557 16.4536 9.31557 16.3536L8.64891 15.687C8.45557 15.4936 8.45557 15.1736 8.64891 14.9803C8.84224 14.787 9.16224 14.787 9.35557 14.9803L9.66891 15.2936L11.3156 13.647C11.5089 13.4536 11.8289 13.4536 12.0222 13.647C12.2156 13.8403 12.2156 14.1603 12.0222 14.3536L10.0222 16.3536C9.92224 16.4536 9.79557 16.5003 9.66891 16.5003Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66891 21.1663C9.54224 21.1663 9.41557 21.1196 9.31557 21.0196L8.64891 20.353C8.45557 20.1596 8.45557 19.8396 8.64891 19.6463C8.84224 19.453 9.16224 19.453 9.35557 19.6463L9.66891 19.9596L11.3156 18.313C11.5089 18.1196 11.8289 18.1196 12.0222 18.313C12.2156 18.5063 12.2156 18.8263 12.0222 19.0196L10.0222 21.0196C9.92224 21.1196 9.79557 21.1663 9.66891 21.1663Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesView);
export default __webpack_public_path__ + "static/media/roles_view.1276f71d46e86ba4fa056e92e62467dd.svg";
export { ForwardRef as ReactComponent };